import { secondHalfPeriodNumber } from "../../utils/context-utils";
import Rule from "../../../common/rule";

export default class SecondHalfPossessionSwitch extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            gameContext.currentPeriod === secondHalfPeriodNumber(gameContext) &&
            play.contextSnapshot.currentPeriod !==
                secondHalfPeriodNumber(gameContext)
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.setPossessionForTeamId(
            gameContext.firstQtrKickoffTeamId === gameContext.homeTeamId
                ? gameContext.awayTeamId
                : gameContext.homeTeamId
        );
    }
}
